<template>
  <div class="body">
    <navbar v-if="!isNative"></navbar>
    <div class="content-body" v-if="!!bindData && !!userData">
      <div class="step-body" v-if="!isNative">
        <div class="step-one">
          <div class="step-active" v-show="step == 1"></div>
          <span :class="{'select-font': step == 1}">确认账号信息</span>
        </div>
        <div class="step-two">
          <div class="step-active" v-show="step == 2"></div>
          <span :class="{'select-font': step == 2}">注销声明</span>
        </div>
      </div>
      <div class="info-body">
        <template v-if="step == 1">
          <div class="user-info">
            <div class="title">账号信息</div>
            <div class="user-info-detail">
              <div class="info-item">
                <p><span>姓</span><span>名:</span></p>
                <span>{{this.personInfo.name}}</span>
              </div>
              <div class="info-item">
                <p><span>微</span><span>信:</span></p>
                <span :style="{color: this.bindData.wechat_is_bound ? '#404040' : '#9c9c9c'}">{{this.bindData.wechat_is_bound ? '已绑定' : '未绑定'}}</span>
              </div>
              <div class="info-item">
                <p>绑定手机:</p>
                <span :style="{color: this.bindData.phone_is_bound ? '#404040' : '#9c9c9c'}">{{this.bindData.phone_is_bound ? this.bindData.phone : '未绑定'}}</span>
              </div>
              <div class="info-item" v-if="userData.hr && Object.keys(userData.hr).length > 0">
                <p>招聘账号:</p>
                <span>{{userData.hr.company_name}} · {{userData.hr.company_position}}</span>
              </div>
              <div class="member" v-if="this.personInfo && this.personInfo.is_membership" style="height: 48px">
                {{isOverMember ? '该账号为终身会员' : `该账号为会员账号，会员到期时间为 ${moment(this.personInfo.membership_expired_at).format('YYYY-MM-DD')}`}}
              </div>
            </div>
            <img class="user-icon" :src="this.personInfo.avatar_url" alt="">
          </div>
          <div class="model-item" v-if="userData.cvs.count && userData.cvs.count > 0">
            <div class="model-top">
              <i class="iconfont iconcuowu"></i> 你的账号下有 <span class="active-color">{{userData.cvs.count}}</span> 份简历，建议下载保存到本地<span v-if="userData.cvs.count > 1 && !isNative" class="all-resumes" @click="linkTo('/cvs')">查看全部简历</span>
            </div>
            <div class="resume-item"  @click="isNative ? '' : linkTo('/cvs')">
              <img src="https://files.wondercv.com/PC/cvs/myresume_red.png" alt="">
              <div style="flex: 1" class="resume-card">
                <p class="resume-name">{{userData.cvs.cv_name}}</p>
                <div class="reusem-bottom">
                  <div style="display: flex" v-if="!isNative">
                    <div class="score">{{userData.cvs.score}}分</div>
                    <div class="lang">{{userData.cvs.lang === 0 ? '中文' : '英文'}}</div>
                  </div>
                  <div class="update-time">
                    修改于：{{moment(userData.cvs.updated_at).format('YYYY-MM-DD')}}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="model-item" v-if="userData.orders.length > 0">
            <div class="model-top">
             <i class="iconfont iconcuowu"></i> 你的账号下有 <span class="active-color">{{userData.orders.length}}</span> 个正在进行的导师辅导订单
            </div>
            <div class="order-list">
              <div @click="linkTo('/account/users?index=3')" class="order-item" v-for="(sitem,sindex) in userData.orders" :key="sindex + 'c'">
                <p>{{sitem.plan | filterPlan}}</p>
                <div class="order-detail">
                  <img src="https://files.wondercv.com/APP/me/orderservice.png" alt="">
                  <div>
                    <p class="order-time"><span>下单时间: </span>{{sitem.pay_time && moment(sitem.pay_time).format('YYYY-MM-DD')}}</p>
                    <p class="order-num"><span>订单号: </span>{{sitem.trade_no}}</p>
                  </div>      
                </div>          
              </div>
            </div>
          </div>
          <div class="model-item" v-if="userData.hr && userData.hr.jobs_data && userData.hr.jobs_data.length > 0">
            <div class="model-top">
             <i class="iconfont iconcuowu"></i> 你的招聘账号下有 <span class="active-color">{{userData.hr.jobs_data.length}}</span> 个在线职位，注销后职位即将下线<span v-if="userData.hr.jobs_data.length > 1" class="all-resumes" @click="linkTo('/talent/joblist')">查看全部在线职位</span>
            </div>
            <div class="job-list">
              <div @click="linkTo('/talent/joblist')" class="job-item" v-for="(item,index) in userData.hr.jobs_data" :key="index + 'a'">
                <div class="job-name">{{item.job_post}}</div>
                <div class="job-bottom-list">
                  <span v-if="!!item.city">{{item.city}}</span>
                  <span v-if="!!item.intern_duration">{{item.intern_duration}}</span>
                  <span v-if="!!item.degree">{{item.degree}}</span>
                  <span v-if="!!item.job_nature">{{item.job_nature}}</span>
                  <span v-if="!!item.salary">{{item.salary}}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="model-item" v-if="userData.hr && userData.hr.order_data && userData.hr.order_data.length > 0">
            <div class="model-top">
              <i class="iconfont iconcuowu"></i> 你的招聘账号下有 <span class="active-color">{{userData.hr.order_data.length}}</span> 个在有效期内的服务订单，剩余 <span class="active-color">{{ !!userData.hr.view_phone_count ? userData.hr.view_phone_count : 0}}</span> 次查看电话
            </div>
            <div class="hr-order-list">
              <div class="hr-order-item" @click="linkTo('/talent/order')" v-for="(sitem,sindex) in userData.hr.order_data" :key="sindex + 'b'">
                <p class="hr-order-name">{{!!sitem.plan ? sitem.plan : sitem.title}}</p>
                <div class="hr-order-bottom" >
                  <p v-html="!!sitem.plan && sitem.plan == '查看电话' ? `查看电话 <span style='color:#ff6644'}}>${sitem.post.split('_')[2]} 次</span>`: sitem.post"></p>
                  <p v-html="!!sitem.plan && sitem.plan == '查看电话' ? '可直接获取候选人联系方式' : sitem.plan == '火爆职位' ? '职位发布后有效期为30天' : `曝光时间：<span style='color:#ff6644'}}>${sitem.text}</span>`"></p>
                </div>
                
              </div>
            </div>
          </div>
          <div class="next-btn" @click="nextStep">
            下一步
          </div>
        </template>
        <div v-else>
          <div class="title">注销声明</div>
          <div class="statement-body">
            <div class="statement-item">
              <div class="statement-title">我们会持续加强简历隐私保护，在注销前，你还可以：</div>
              <div class="jump-to-operate">
                <p @click="isNative ? '' : linkTo('/account/users?index=2')">去屏蔽企业 {{isNative ? '' : '>>'}} </p>
                <p @click="isNative ? '' : linkTo('/account/users?index=2')">去设置简历是否可见 {{isNative ? '' : '>>'}} </p>
              </div>
            </div>
            <div class="statement-item">
              <div class="statement-title">注意事项：</div>
              <div class="becareful">
                <p>1. 注销账号将注销你在超级简历中的所有账号，包括但不限于求职账号和招聘账号，且账号无法找回。</p>
                <p>2. 注销后，你将无法登录、使用本超级简历账号，招聘方将无法通过本账号联系你。</p>
                <p>3. 注销前请你查看并仔细阅读《超级简历注销协议》的全部内容。</p>
              </div>
            </div>
            <div class="statement-item">
              <div class="statement-title">注销后，你将放弃以下权益：</div>
              <div class="becareful">
                <p>1. 该求职账号下购买的会员、简历修改、面试辅导、求职规划服务以及招聘账号下购买的招聘道具，注销账号将视为你自动放弃前述未完成的服务。</p>
                <p>2. 注销后，账号内所有订单服务将无法退还或找回。</p>
                <p>3. 注销后，你将无法找回账号曾登录的超级简历PC端、手机APP端、小程序端的所有记录。</p>
              </div>
            </div>
            <div>

            </div>
          </div>
          <div class="agreement">
            <el-checkbox v-model="checkedReadMe"></el-checkbox> 我已阅读并同意 <span @click="linkTo('/account/chancel_agreement','_blank')">《超级简历注销协议》</span>
          </div>
          <div class="step2-btn">
            <div @click="step = 1">上一步</div>
            <div :class="{'disable':!checkedReadMe}" @click="showChancleDialog">确认注销</div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog top='228px' :width="isNative ? '350px' : '588px'" :visible.sync="showDialog" :show-close='false' :close-on-click-modal='false'> 
      <div class="chancel-reason">
        <p>确认注销</p>
        <p>请选择注销的原因（单选）</p>
        <cv-radio :value='radioVal' line='more' :list='radioList' @change='radioChange'></cv-radio>
        <el-input
          v-show="showInput"
          maxlength="50"
          show-word-limit
          type="textarea"
          :rows="4"
          placeholder="请输入其他原因"
          v-model="reasonVal">
        </el-input>
        <div class="reason-btn">
          <div @click="()=>{showDialog = false}">取消</div>
          <div :class="{'disable': !canLogout}" @click="logout">立即注销</div>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import {mapState, mapGetters, mapMutations} from 'vuex'
import navbar from '../../../components/base/navbar.vue'
import cvRadio from '@/components/base/cvRadio'
import api from '@/api';
import { auth, routerTo, get_tUser, updateJWT } from '@/assets/js/util';
import moment from 'moment'
import CvRadio from '../../../components/base/cvRadio.vue';
import Cookies from 'js-cookie'
window.Cookies = Cookies;
export default {
  components: { navbar,cvRadio, CvRadio },
  name:'cancel',
  computed:{
    ...mapState('me', ['isLogin', 'personInfo']),
    // 是否是终身会员(是会员的前提下)
    isOverMember() {
      return this.personInfo && this.personInfo.is_membership && this.personInfo.membership_expired_at.substr(0,4) >= 2100
    },
    // 能否立即注销
    canLogout(){
      return this.showInput ? !!this.reasonVal : !!this.radioVal
    }
  },
  async created(){
    let query = this.$route.query
    if (query.jwt) {
      this.isNative = true
      // 自动更新 jwt
      await updateJWT({
        jwt: query.jwt
      })
      setTimeout(() => {
        let udesk_container = document.querySelector('#udesk_container')
        udesk_container.style.display = 'none'
      }, 3 * 1000)
    }
    // 获取账号绑定信息
    this.getUsersInfo()
    this.getAccountInfo()
  },
  watch:{
    radioVal(val){
      this.showInput = val == 5
    }
  },
  filters:{
    filterPlan(val){
      let text = '导师辅导-'
      return val ==  'intern' ? text + '实习版' : val == 'campus' ? text + '校招版' : text + '在职版'
    }
  },
  data(){
   return {
     bindData: null,
     userData: null,
     step: 1,
     showDialog: false,
     showInput: false, // 展示其他原因输入框
     radioVal: '',
     reasonVal: '', // 其他原因
     checkedReadMe: false, // 阅读协议
     isNative: false,   // 是否是 APP 打开的
     radioList:[
       {
         value: '0',
         content: '已有其他账号，不需要这个账号了'
       },
        {
         value: '1',
         content: '我换手机号了，重新注册'
       },
       {
         value: '2',
         content: '我找到新工作'
       },
        {
         value: '3',
         content: '我担心隐私泄露'
       },
       {
         value: '4',
         content: '功能不好用'
       },
        {
         value: '5',
         content: '其他原因'
       }
     ],
     moment
   }
  },
  methods:{
    // 获取用户绑定信息
    async getUsersInfo(){
      let user_token = get_tUser().t || '';
      if(!!user_token) {
        let res = await api.auth.get_users_bind_info(user_token)
        if(res.code === 1000){
          this.bindData = res.data;
        }
      }
    },
    // 获取账号下的信息
    async getAccountInfo(){
      let res = await api.account.beforeUserChancel()
      if(res.code === 1000) {
        this.userData = res.data
      }
    },
    // 注销原因变化
    radioChange(val){
      this.reasonVal = '' // 切换清空其他原因输入框
      this.radioVal = val
    },
    // 链接
    linkTo(url,type='_blank'){
      routerTo(url,type)
    },
    // 确认注销
    async logout(){
      if(!this.canLogout) {
        this.$message.error('请勾选一种注销原因')
        return
      }
      let param = {
        source: 'PC',
        reason: this.showInput ? this.reasonVal : this.radioList[parseInt(this.radioVal)].content 
      }
      // console.log(param);
      let res = await api.account.logout(param)
      if(res.code === 1000) {
        this.$message.success('注销成功')
        let url = window.location.hostname;
        let domain = url.replace(/.*?(\.wondercv.(cn|com))/gim, '$1');
        Cookies.remove('_t', {domain});
        if (window.ReactNativeWebView) {
          window.ReactNativeWebView.postMessage(JSON.stringify({
            type: 'accountDestroy',
            data: true
          }))
        } else {
          routerTo('/')
        }
      } else {
        this.$message.error(res.data.message)
      }
    },
    // 注销原因弹框
    showChancleDialog(){
      if(!this.checkedReadMe) {
        this.$message.error('请确认勾选《超级简历注销协议》')
        return
      }
       this.radioVal = ''
       this.showDialog = true
    },
    // 下一步
    nextStep(){
      // 有hr账号才有后面的判断
      // 不是hr的情况 可能hr字段没有也可能是{}
      if(this.userData.orders.length == 0 && ((!this.userData.hr || Object.keys(this.userData.hr).length == 0) ? true : this.userData.hr.view_phone_count == 0 && this.userData.hr.hot_job_count == 0 && this.userData.hr.top_job_count == 0)){
        this.step = 2
      }
      else {
        this.$message.error('你当前有未完成的订单，无法注销账号')
      }
      // this.step = 2
    }
  }
}
</script>

<style scoped lang="scss">
  ::v-deep .el-dialog__header{
    display: none;
  }
  ::v-deep .el-dialog dialog{
    border-radius: 4px;
  }
  ::v-deep .el-dialog__body{
     padding: 32px;
  }
  ::v-deep .el-checkbox__inner:hover {
    border-color: #ff6644;
  }
  ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner{
    background-color: #FF6644;
    border-color: #FF6644;
  }
  @mixin font-style($s,$c,$w){
    font-size: $s;
    color: $c;
    font-weight: $w;
  }
  .active-color{
    color: #ff6644 !important;
  }
  .select-font{
    font-size: 16px !important;
    color: #404040 !important;
    font-weight: 500 !important;
  }
  .agreement{
    margin-top: 37px;
    @include font-style(14px,#404040,400);
    &>span{
      text-decoration-line: underline;
      cursor: pointer;
    }
  }
  .member{
    background-image: url('https://files.wondercv.com/PC/VIP_Accountcancellation.png');
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    padding-left: 50px;
    @include font-style(14px,#FBEFE0,500);
  }
  .body{
    margin: auto;
    width: 1116px;
    .title{
      @include font-style(18px,#404040,600);
    }
  }
  .content-body{
    display: flex;
    margin-top: 80px;
    margin-bottom: 60px;
    .step-body{
      width: 260px;
      height: 223px;
      background: #FFFFFF;
      border-radius: 6px;
      margin-right: 24px;
      display: flex;
      flex-direction: column;
      align-items: center; 
      position: relative;
      .step-active{
        width: 8px;
        height: 26px;
        background: #FF6644;
        position: absolute;
        left: 57px;
      }
      .step-one::after{
        content: '';
        position: absolute;
        bottom: 0;
        left: -70px;
        display: block;
        width: 238px;
        height: 1px;
        background-color: #F5F5F7;
      }
      .step-one,.step-two{
        position: relative;
        display: flex;
        flex: 1;
        align-items: center;
        width: 100%;
        cursor: pointer;
        justify-content: center;
        &>span{
          @include font-style(16px, #666, 400);
        }
      }
    }
    .info-body{
      width: 832px;
      background: #FFFFFF;
      border-radius: 6px;
      box-sizing: border-box;
      padding: 32px 32px 48px 32px;
      .user-icon{
        width: 60px;
        height: 60px;
        object-fit: contain;
        border-radius: 50%;
        position: absolute;
        right: 0;
        top: 70px;
      }
      .user-info{
        position: relative;
      }
      .user-info-detail{
        margin-top: 16px;
        border-top: 1px solid #F4F4F4;
        padding-top: 32px;
        position: relative;
        .info-item{
          display: flex;
          margin-bottom: 18px;
          &>p{
            width: 60px;
            display: flex;
            justify-content: space-between;
            @include font-style(14px,#9C9C9C,400);
            margin-right: 32px;
          }
          &>span{
            @include font-style(14px,#404040,400);
          }
        }
      }
      .model-item{
        margin-top: 32px;
        border-top: 1px solid #F4F4F4;
        padding-top: 32px;
        .model-top{
          &>i{
            color: #FF6644;
            font-size: 16px;
          }
          @include font-style(16px,#404040,500);
          .all-resumes{
            cursor: pointer;
            margin-left: 16px;
            @include font-style(16px,#ff6644,400);
            text-decoration-line: underline;
            &:hover{
              font-weight: bold;
            }
          }
        }
        .resume-item{
          padding: 16px 18px;
          box-sizing: border-box;
          width: 343px;
          height: 74px;
          background: #FAFBFD;
          border-radius: 6px;
          margin-top: 16px;
          display: flex;
          cursor: pointer;
          &:hover{
            box-shadow: (0 2px 12px 0 rgba(25,44,81,0.1));
            background: #fff;
          }
          &>img{
            width: 34px;
            height: 42px;
            margin-right: 12px;
          }
          .resume-name{
            @include font-style(14px,#404040,500);
          }
          .reusem-bottom{
            display: flex;
            margin-top: 11px;
            justify-content: space-between;
            .score{
              padding: 2px 5px;        
              color: #FF6644;
              background: #FFEFEC;
              margin-right: 6px;
              font-size: 11px;
              border-radius: 2px;
            }
            .lang{
              padding: 2px 5px;
              color: #9C9C9C;      
              border-radius: 2px;
              background: #F4F4F4;
              font-size: 11px;
            }     
            .update-time{
              @include font-style(14px,#9c9c9c,400);
            }
          }
        }
        .order-list,.job-list,.hr-order-list{
          display: flex;
          margin-top: 16px;
          flex-wrap: wrap;
           &>:nth-child(odd){
            margin-right: 16px;
          }  
        }
          
        .order-item{
          width: 343px;
          height: 116px;
          background: #FAFBFD;
          border-radius: 6px; 
          padding: 18px;
          box-sizing: border-box;
          cursor: pointer;  
          margin-bottom: 16px; 
          &:hover{
            box-shadow: (0 2px 12px 0 rgba(25,44,81,0.1));
            background: #fff;
          }  
          .order-detail{
            display: flex;
            &>img{
              width: 43px;
              height: 43px;
              object-fit: contain;
              margin-right: 11px;
            }
            .order-time{
              margin-bottom: 12px;
            }
            .order-num,.order-time{
              @include font-style(14px,#606060,400);
              &>span{
                width: 70px;
                display: inline-block;
              }
            }
          }
          &>p:nth-of-type(1){
            @include font-style(14px,#404040,600);
            margin-bottom: 20px;
          }

        }
        .job-item{
          width: 343px;
          height: 70px;
          background: #FAFBFD;
          border-radius: 6px;
          box-sizing: border-box;
          padding: 16px 20px;
          cursor: pointer;
          &:hover{
            box-shadow: (0 2px 12px 0 rgba(25,44,81,0.1));
            background: #fff;
          }
          .job-name{
            @include font-style(14px,#404040,500);
          }
          .job-bottom-list{
            display: flex;
            margin-top: 8px;
            &>span{
              display: flex;
              align-items: center;
              @include font-style(14px,#9c9c9c,400);
              &::after{
                content: '';
                display: block;
                // position: relative;
                width: 1px;
                height: 9px;
                background: #ECECEC;
                margin: 0 6px;
              }
              &:last-child{
                &::after{
                  display: none;
                }
              }
            }
          }
          &:nth-of-type(1){
            margin-right: 16px;
          }   
        }
        .hr-order-item{
          width: 343px;
          height: 106px;
          background: #FAFBFD;
          border-radius: 6px;
          padding: 18px;
          box-sizing: border-box;
          cursor: pointer;
          margin-bottom: 16px;
          &:hover{
            box-shadow: (0 2px 12px 0 rgba(25,44,81,0.1));
            background: #fff;
          }
          .hr-order-bottom{
            &>p{
              @include font-style(14px,#606060,400);
            }
            &>p:nth-of-type(1){
              margin-bottom: 10px;
            }
          }
          .hr-order-name{
            @include font-style(14px,#404040,600);
            margin-bottom: 16px;
          }
          &:nth-of-type(1){
            margin-right: 16px;
          }
        }
      }
      .next-btn{
        width: 274px;
        height: 46px;
        background: #FF6644;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        &:hover{
          background: #FF8569;
        }
        @include font-style(16px,#fff,500);
        margin: auto;
        margin-top: 48px;
      }
      .not-step{

      }
    }
    .statement-body{
      margin-top: 40px;
      .statement-title{
        @include font-style(16px, #404040, 500);
        margin-bottom: 16px;
      }
      .statement-item{
        margin-top: 36px;
        .jump-to-operate{
          &>p{
            @include font-style(14px, #ff6644, 400);
            margin-bottom: 12px;
            cursor: pointer;
          }
        }
        .becareful{
          &>p{
            @include font-style(13px, #606060, 400);
            line-height: 24px;
          }
        }
      }
     
    }
     .step2-btn{
        margin: auto;
        display: flex;
        justify-content: center;
        margin-top: 50px;
        &>div{
          width: 129px;
          height: 46px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 4px;
          cursor: pointer;
        }
        &>div:nth-of-type(1){
          @include font-style(16px, #ff6644, 500);
          background: #FFFFFF;
          border: 1px solid #FF6644;
          margin-right: 16px;
        }
        &>div:nth-of-type(2){
          @include font-style(16px, #feffff, 500);
          background: #FF6644;
          &:hover{
            background: #FF8569;
          }
        }
      }
  }
  .chancel-reason{
    // width: 588px;
    // height: 304px;
    background: #FFFFFF;
    border-radius: 4px;
    box-sizing: border-box;
    // padding: 32px;
    padding-top: 0;
    &>p:nth-of-type(1){
      @include font-style(18px,#404040,500);
    }
    &>p:nth-of-type(2){
      @include font-style(14px,#9c9c9c,400);
      margin-top: 14px;
      margin-bottom: 36px;
    }
  }
  .reason-btn{
    display: flex;
    margin-top: 38px;
    overflow: hidden;
    justify-content: right;
    &>div{
      float: right;
      width: 84px;
      height: 36px;
      border-radius: 2px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }
    &>div:nth-of-type(1){
      @include font-style(14px,#606060,400);
       border: 1px solid #D9D9D9;
       margin-right: 16px;
    }
    &>div:nth-of-type(2){
      @include font-style(14px,#fff,400);
      background: #FF6644;
    }
    .disable{  
      background: #CFCFCF !important;
    }
  }
  .disable{  
    background: #CFCFCF !important;
  }
  @media only screen and (max-width: 430px) {
    .body {
      width: calc(100vw - 40px);
      .content-body {
        width: 100%;
        .info-body {
          width: 100%;
          .model-top {
            text-align: center;
            line-height: 20px;;
          }
          .resume-item {
            width: 100%;
            .resume-card {
              width: 100%!important;
              .resume-name {
                width: 100%;
              }
              .reusem-bottom {
                width: 100%;
              }
            }
          }
        }
      }
    }
  }
</style>
